import { useState } from 'react'
import { SEVERITIES, SEVERITY_LABELS, type DrspItem, type Severity } from '../drsp'

interface Props {
  item: DrspItem
  value: Severity | undefined
  onChange: (value: Severity | null) => void
}

/**
 * One item of the form: the label, and six tap targets.
 * Tapping the current value again clears it, mirroring the paper form where a
 * box can simply be left blank.
 */
export default function RatingRow({ item, value, onChange }: Props) {
  const [expanded, setExpanded] = useState(false)

  return (
    <div className="item">
      <div className="item-head">
        <span className="item-num">{item.id}</span>
        <div className="item-label">
          {item.short}
          {expanded && <p className="item-full">{item.text}</p>}
        </div>
        <span className="scale-caption">{value ? SEVERITY_LABELS[value] : ''}</span>
        <button
          type="button"
          className="item-info"
          aria-expanded={expanded}
          aria-label={`Full wording for item ${item.id}`}
          onClick={() => setExpanded((v) => !v)}
        >
          {expanded ? '×' : 'i'}
        </button>
      </div>

      <div className="scale" role="group" aria-label={item.short}>
        {SEVERITIES.map((s) => (
          <button
            key={s}
            type="button"
            data-sev={s}
            aria-pressed={value === s}
            aria-label={`${s} — ${SEVERITY_LABELS[s]}`}
            onClick={() => onChange(value === s ? null : s)}
          >
            {s}
          </button>
        ))}
      </div>
    </div>
  )
}
